import React, { Component } from "react"

class About extends Component {
  render() {
    return (
      <>
        <div id="about" className="container">
          <div className="pt-5 pb-5 d-flex justify-content-center">
            <h1 className="edsider-section-title white-section-title">About Us</h1>
          </div>
          <p className="pb-5 d-flex justify-content-center text-center about-para">
            At EdSider, we are dedicated in empowering students, providing{" "}
            <br />
            educational materials for the academic excellence and unlocking full{" "}
            <br /> potential of every learner
          </p>
          <div className="row">
            <div className="col-md-6">
              <div className="card-container">
                <div className="about-card">
                  <div className="about-card-body">
                    <h1 className="d-flex justify-content-center about-card-title">Mission</h1>
                    <p className="d-flex justify-content-center text-center about-card-text">
                      “Empowering Students for Success: Revolutionizing
                      Education through Comprehensive, Exceptional, and
                      Accessible Learning Resources”
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="card-container">
                <div className="about-card">
                  <div className="about-card-body">
                    <h1 className="d-flex justify-content-center about-card-title">Vision</h1>
                    <p className="d-flex justify-content-center text-center about-card-text">
                      “Unleashing Potential: Redefining Education with Engaging
                      and Accessible Learning Resources”
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default About
